import React, { useCallback, useEffect, useState } from 'react';
import { Input, Form, notification } from 'antd';
import { Button } from '@ui/components';
import { createSoap, getSoap, ISoap, updateSoap } from '@ui/api/v2/soap.api';
import { useFormik } from 'formik';

const { Item } = Form;

export function SoapForm() {
  const [soap, setSoap] = useState<ISoap>();

  const fetchSoap = useCallback(async () => {
    const { data } = await getSoap();
    if (data) {
      setSoap(data);
    }
  }, []);

  useEffect(() => {
    void fetchSoap();
  }, [fetchSoap]);

  const formik = useFormik({
    initialValues: {
      server: '',
      login: '',
      password: '',
      catalog: '',
      database: '',
    },
    async onSubmit(values) {
      let result;
      if (soap) {
        result = await updateSoap(soap.id, values);
      } else {
        result = await createSoap(values);
      }
      if (result.ok) {
        notification.success({
          message: 'Данные обновлены',
        });
      } else {
        notification.error({
          message: 'Произошла ошибка',
        });
      }
    },
  });

  useEffect(() => {
    if (soap) {
      formik.setValues({
        server: soap.server,
        login: soap.login,
        password: soap.password,
        catalog: soap.catalog,
        database: soap.database,
      });
    }
  }, [soap]);

  return (
    <form onSubmit={formik.handleSubmit} className="soap__form">
      <Item label="Сервер">
        <Input value={formik.values.server} onChange={formik.handleChange} type="text" name="server" />
      </Item>
      <Item label="Логин">
        <Input value={formik.values.login} onChange={formik.handleChange} type="text" name="login" />
      </Item>
      <Item label="Пароль">
        <Input value={formik.values.password} onChange={formik.handleChange} type="text" name="password" />
      </Item>
      <Item label="Каталог">
        <Input value={formik.values.catalog} onChange={formik.handleChange} type="text" name="catalog" />
      </Item>
      <Item label="База">
        <Input value={formik.values.database} onChange={formik.handleChange} type="text" name="database" />
      </Item>
      <div className="soap__buttons-wrapper">
        <Item>
          <Button type="primary" htmlType="submit">
            Обновить
          </Button>
        </Item>
      </div>
    </form>
  );
}



// WEBPACK FOOTER //
// ./src/components/Soap/SoapForm.tsx